import { Box, Typography, Grid, Paper } from '@mui/material';
import { People as PeopleIcon, Share as ShareIcon, AutoAwesome as AutoAwesomeIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

const ResellerOrganizationBrandLimitDetails = ({ orgLimitationDetails }) => {
  const { t: translate } = useTranslation();
  return (
    <Box sx={{ mx: 1, mb: 2 }}>
      <Box sx={{ width: '100%' }}>
        <Box>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              flexWrap: 'wrap',
              mb: 1.5,
            }}
          >
            <Typography variant="h5" fontWeight="bold">
              {translate('reseller_org_limits.organization_plan_limits', 'Organization Plan Limits')}
            </Typography>
          </Box>
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <Paper
                elevation={3}
                sx={{
                  p: 2,
                  height: '100%',
                  borderLeft: '4px solid #3f51b5',
                  borderRadius: '8px',
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1.5 }}>
                  <PeopleIcon color="primary" sx={{ mr: 1 }} />
                  <Typography variant="subtitle1" fontWeight="bold">
                    {translate('reseller_org_limits.user_limits', 'User Limits')}
                  </Typography>
                </Box>

                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    mb: 1,
                    p: 1,
                    bgcolor: '#f5f5f5',
                    borderRadius: '4px',
                  }}
                >
                  <Typography>{translate('reseller_org_limits.total_allowed', 'Total Allowed:')}</Typography>
                  <Typography fontWeight="bold">{orgLimitationDetails.total_users}</Typography>
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    mb: 1,
                    p: 1,
                  }}
                >
                  <Typography>{translate('reseller_org_limits.allocated', 'Allocated:')}</Typography>
                  <Typography fontWeight="bold">{orgLimitationDetails.total_users_allocated}</Typography>
                </Box>

                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    p: 1,
                    bgcolor: '#e8f5e9',
                    borderRadius: '4px',
                  }}
                >
                  <Typography>{translate('reseller_org_limits.remaining', 'Remaining:')}</Typography>
                  <Typography fontWeight="bold" color="success.main">
                    {orgLimitationDetails.total_users - orgLimitationDetails.total_users_allocated}
                  </Typography>
                </Box>
              </Paper>
            </Grid>

            <Grid item xs={12} md={4}>
              <Paper
                elevation={3}
                sx={{
                  p: 2,
                  height: '100%',
                  borderLeft: '4px solid #ff9800',
                  borderRadius: '8px',
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1.5 }}>
                  <ShareIcon color="secondary" sx={{ mr: 1 }} />
                  <Typography variant="subtitle1" fontWeight="bold">
                    {translate('reseller_org_limits.social_account_limits', 'Social Account Limits')}
                  </Typography>
                </Box>

                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    mb: 1,
                    p: 1,
                    bgcolor: '#f5f5f5',
                    borderRadius: '4px',
                  }}
                >
                  <Typography>{translate('reseller_org_limits.total_allowed', 'Total Allowed:')}</Typography>
                  <Typography fontWeight="bold">{orgLimitationDetails.total_social_accounts}</Typography>
                </Box>

                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    mb: 1,
                    p: 1,
                  }}
                >
                  <Typography>{translate('reseller_org_limits.allocated', 'Allocated:')}</Typography>
                  <Typography fontWeight="bold">{orgLimitationDetails.total_social_accounts_allocated}</Typography>
                </Box>

                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    p: 1,
                    bgcolor: '#e8f5e9',
                    borderRadius: '4px',
                  }}
                >
                  <Typography>{translate('reseller_org_limits.remaining', 'Remaining:')}</Typography>
                  <Typography fontWeight="bold" color="success.main">
                    {orgLimitationDetails.total_social_accounts - orgLimitationDetails.total_social_accounts_allocated}
                  </Typography>
                </Box>
              </Paper>
            </Grid>

            <Grid item xs={12} md={4}>
              <Paper
                elevation={3}
                sx={{
                  p: 2,
                  height: '100%',
                  borderLeft: '4px solid #4caf50',
                  borderRadius: '8px',
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1.5 }}>
                  <AutoAwesomeIcon color="success" sx={{ mr: 1 }} />
                  <Typography variant="subtitle1" fontWeight="bold">
                    {translate('reseller_org_limits.ai_credits', 'AI Credits')}
                  </Typography>
                </Box>

                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    mb: 1,
                    p: 1,
                    bgcolor: '#e3f2fd',
                    borderRadius: '4px',
                  }}
                >
                  <Box>
                    <Typography variant="caption">
                      {translate('reseller_org_limits.text_credits', 'Text Credits')}
                    </Typography>
                    <Typography fontWeight="bold" color="info.main">
                      {orgLimitationDetails.available_ai_credit / 100}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography variant="caption">{translate('reseller_org_limits.allocated', 'Allocated')}</Typography>
                    <Typography fontWeight="bold" color="info.main">
                      {orgLimitationDetails.available_ai_credit_allocated / 100}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography variant="caption">{translate('reseller_org_limits.remaining', 'Remaining')}</Typography>
                    <Typography fontWeight="bold" color="info.main">
                      {(orgLimitationDetails.available_ai_credit - orgLimitationDetails.available_ai_credit_allocated) /
                        100}
                    </Typography>
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    mb: 1,
                    p: 1,
                    bgcolor: '#e3f2fd',
                    borderRadius: '4px',
                  }}
                >
                  <Box>
                    <Typography variant="caption">
                      {translate('reseller_org_limits.image_credits', 'Image Credits')}
                    </Typography>
                    <Typography fontWeight="bold" color="info.main">
                      {orgLimitationDetails.available_ai_image_credit}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography variant="caption">{translate('reseller_org_limits.allocated', 'Allocated')}</Typography>
                    <Typography fontWeight="bold" color="info.main">
                      {orgLimitationDetails.available_ai_image_credit_allocated}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography variant="caption">{translate('reseller_org_limits.remaining', 'Remaining')}</Typography>
                    <Typography fontWeight="bold" color="info.main">
                      {orgLimitationDetails.available_ai_image_credit -
                        orgLimitationDetails.available_ai_image_credit_allocated}
                    </Typography>
                  </Box>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Box>
  );
};

export default ResellerOrganizationBrandLimitDetails;
